document.addEventListener('DOMContentLoaded', function() {
  // const triggers = document.querySelectorAll('.bd-product-highlight-trigger');
  const overlays = document.querySelectorAll('.bd-modal-overlay');
  
  // triggers.forEach(trigger => {
  //   trigger.addEventListener('click', function() {
  //     const modal = document.getElementById('modal-' + this.dataset.blockId);
  //     if (modal) {
  //       modal.classList.add('active');
  //     }
  //   });
  // });
  
  overlays.forEach(overlay => {
    overlay.addEventListener('click', function() {
      this.closest('.bd-product-highlight-modal').classList.remove('active');
    });
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.bd-product-highlight-modal.active');
      if (activeModal) {
        activeModal.classList.remove('active');
      }
    }
  });
  
  document.querySelectorAll('.bd-color-swatch input').forEach(input => {
    input.addEventListener('change', function() {
      const modal = this.closest('.bd-product-highlight-modal');
      const img = modal.querySelector('[data-main-image] img');
      const price = modal.querySelector('.bd-current-price');
      const compare = modal.querySelector('.bd-compare-price');
      
      if (this.dataset.image && img) img.src = this.dataset.image;
      if (this.dataset.price && price) price.textContent = this.dataset.price;
      if (this.dataset.compare && compare) compare.textContent = this.dataset.compare;
    });
  });
});

//product highight tab view
document.addEventListener('DOMContentLoaded', () => {
  const tabItems = document.querySelectorAll('.bd-tabs-nav .tab-item');
  const tabPanes = document.querySelectorAll('.tab-pane');

  tabItems.forEach(item => {
    item.addEventListener('click', () => {
      const tabId = item.getAttribute('data-tab');

      tabItems.forEach(i => i.classList.remove('active'));
      tabPanes.forEach(pane => pane.classList.remove('active'));

      item.classList.add('active');
      document.getElementById(tabId).classList.add('active');
    });
  });
});